import { useSyncExternalStore } from 'react';

/*
 * The support code (`CAP-XXXXXX`) of the most recent failed API call. The HTTP client records it
 * on every error (null when the server sent none, e.g. offline or an older server), so a generic
 * error screen can show the code of the failure that put it there.
 */
let current: string | null = null;
const listeners = new Set<() => void>();

export function recordErrorRef(ref: string | null): void {
  if (ref === current) return;
  current = ref;
  for (const listener of listeners) listener();
}

export function useLastErrorRef(): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
    () => null,
  );
}
